import { useSelector } from 'react-redux';
import { isVirtualBraindateOverlayShown } from 'plugin/virtual-braindate/selector/virtualBraindateSelectors';

export default function useVirtualBraindateOverlayShown(): ?boolean {
  return useSelector(isVirtualBraindateOverlayShown);
}
